import { Trans } from "react-i18next";

import type { NotificationContentProps } from "../../types";

export default function AiFormatReviewContent({
  ownerChallenge,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey={
        status === "success"
          ? "notifications.aiFormatReviewSuccess"
          : status === "pending"
            ? "notifications.aiFormatReview"
            : "notifications.aiFormatReviewFailed"
      }
      values={{ challenge: ownerChallenge?.name || "Deleted" }}
    />
  );
}
